import { requestJSON } from "./http";

const getData = (accessToken) =>
  requestJSON({ path: "/zendesk/info", accessToken });

export default {
  getData,
};
